import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import Resource from "src/containers/Resource"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  RESOURCES_URL,
  RESOURCES_ID_URL,
  DEFAULT_UUID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

const ResourcePage = (
  <BaseLayout title="Ресурсы">
    <Switch>
      <Route path={RESOURCES_URL} exact component={Resource} />
      <Route
        path={RESOURCES_ID_URL}
        component={withRouteValidation({
          routeValidationConfig: DEFAULT_UUID_VALIDATION_CONFIG,
          isSideModal: true,
        })(Resource)}
      />
    </Switch>
  </BaseLayout>
)

export default (
  <Route path={RESOURCES_URL}>
    <Switch>
      <Route path={RESOURCES_URL} exact>
        {ResourcePage}
      </Route>
      <Route path={RESOURCES_ID_URL}>{ResourcePage}</Route>
    </Switch>
  </Route>
)
